import cx from "classnames";

import Box, { BoxProps } from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";

import styles from "./styles.module.css";
import { CollapsibleSectionContext } from "./Context";

type CollapsibleSectionContentProps = {
  gap?: BoxProps["gap"];
  fullbleed?: boolean;
} & BoxProps;

function CollapsibleSectionContent({
  children,
  gap,
  fullbleed,
  ...restBoxProps
}: CollapsibleSectionContentProps) {
  const { isCollapsed, contentId } = useTypedContext(CollapsibleSectionContext);

  return (
    <Box
      className={cx(styles.collapsible, fullbleed && styles.fullbleed)}
      grid
      gridTemplate="1fr"
      id={contentId}
      {...(isCollapsed ? { ["aria-hidden"]: true } : null)}
    >
      <Box className={styles.collapsibleContent} direction="column" gap={gap} {...restBoxProps}>
        {children}
      </Box>
    </Box>
  );
}

CollapsibleSectionContent.displayName = "DS.CollapsibleSection.Content";

export default CollapsibleSectionContent;
